<template>
  <div class="page" id="improtPoint">
    <a-modal title="导入选点" :visible="visible" @ok="newHandleOk" @cancel="offPop">
      <div style="margin: 10px 0">
        <span style="color: rgba(0, 0, 0, 0.85)">导入选点：</span>
        <a-radio-group name="radioGroup" :default-value="1">
          <a-radio
            @change="valChange"
            :value="index + 1"
            v-for="(item, index) in form.unit"
            :key="index"
          >
            {{ item.name }}
          </a-radio>
        </a-radio-group>
      </div>

      <a-form-model-item label="下载模板：" style="display: flex; margin: 8px 0">
        <div class="dow" @click="dowTemplate">
          <!-- <img src="../../static/image/dowFile.png" alt=""> -->
          <span>
            <a-icon type="download" /> 下载{{ param.value == 1 ? '网点' : '点位' }}资源模板
          </span>
        </div>
      </a-form-model-item>

      <!-- <img src="../../static/image/dowFile.png" alt=""> -->
      <span class="title">上传文件：</span>
      <a-upload
        name="multipartFile"
        :beforeUpload="beforeUploadFun"
        :action="uploadMaterialImgUrl"
        :headers="headers"
        accept=".xls,.xlsx"
        @change="handleChange"
        :fileList="awitDealWithData"
        :data="{
          importType: param.value,
          spaceId: param.spaceId,
          ...sendFileObj
        }"
      >
        <span class="goUp">
          <a-icon type="upload" />点击上传{{ param.value == 1 ? '网点' : '点位' }}
        </span>
      </a-upload>
      <p class="instructions">支持拓展名：xls、xlsx</p>
    </a-modal>
    <!--点击确定弹窗口隐藏 表格弹窗出现  -->
    <a-modal title="导入结果" :visible="tablePop" @cancel="tablePopFun(2)" width="80%">
      <template slot="footer">
        <a-button v-if="!selectBox" type="primary" @click="tablePopFun(1)">确定</a-button>
        <a-button @click="tablePopFun(2)">取消</a-button>
      </template>
      <div>
        <a-alert showIcon type="info">
          <template>
            <div slot="message" class="content-line">
              已成功导入{{ param.value == 1 ? '网点' : '点位' }}
              <span v-if="param.value == 1">{{ newNum == 0 ? 0 : onesDel }}</span>
              <span v-else>{{ forData.successCount }}</span> 个，导入失败{{
                param.value == 1 ? '网点' : '点位'
              }}
              <span>{{ forData.errorCount }}</span> 个
              <span class="a" @click="dowLoad(param.value)"
                >下载失败{{ param.value == 1 ? '网点' : '点位' }}</span
              >
            </div>
          </template>
        </a-alert>
      </div>
      <!--param.value  -->
      <div class="switch">
        <p
          v-for="(item, index) in param.value == 2 ? UnitType.unit : UnitType.net"
          :key="index"
          class="unitClass"
          :class="selectBox == index ? 'addUti' : ''"
          @click="selecClick(index)"
        >
          {{ item }}
        </p>
        <!--成功的时候选中的点数  -->
        <span class="prompt" v-show="!selectBox && param.value == 2"
          >提示：已选择 <span>{{ dataSource.length }}</span> 个点位</span
        >
        <span class="prompt" v-show="!selectBox && param.value == 1"
          >提示：已选择
          <span>{{ newNum == 0 ? 0 : onesDel }}</span>
          个网点资源， <span>{{ newNum }}</span
          >个点位</span
        >
      </div>
      <a-table
        bordered
        :customHeaderRow="handleClickRow"
        :data-source="dataSource"
        :columns="columns"
        @change="changePage"
        :pagination="pagePagination"
      >
        <template slot="operation" slot-scope="text, record, index">
          <!--出现移出此项，有数据 选的是网点 是成功状态  -->
          <a-popconfirm
            v-if="dataSource.length && param.value == 1 && selectBox == 0"
            title="确定删除此项吗？"
            @confirm="() => onDelete(record.key, index)"
          >
            <a href="javascript:;" class="delText">移除</a>
          </a-popconfirm>
        </template>
      </a-table>
    </a-modal>
  </div>
</template>

<script>
import api from '../../../commomFun/api.js'
import { config, baseURL } from '../../../utils/config'
import { dowLoadFile, formHeardData } from '../../../commomFun/public'

export default {
  props: {
    // 弹窗显隐
    visible: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      selectBox: 0, //当前选中的是成功还是失败
      UnitType: {
        unit: ['成功点位', '失败点位'],
        net: ['成功网点资源', '失败网点资源']
      },
      form: {
        unit: [{ name: '网点' }, { name: '点位' }]
      },
      param: {
        value: 1,
        spaceId: 0
      },
      headers: {
        token: '',
        uid: ''
      },
      uploadMaterialImgUrl: config.getFileUrL,
      tablePop: false,
      dataSource: [],
      count: 1,
      columns: [], //表格头部数据源
      awitDealWithData: [], //脏数据
      forData: {}, //总数据
      pagePagination: {
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        showQuickJumper: true,
        total: 0,
        showSizeChanger: true
      },
      newNum: 0, //减去之后的数字
      delPage: 1,
      delSize: 10,
      delThisPage: false,
      onesDel: 0,
      sendFileObj: {}
    }
  },
  created() {
    let user = JSON.parse(sessionStorage.getItem('userInfo'))
    this.headers.token = user.token
    this.headers.uid = user.userId
  },
  mounted() {},
  methods: {
    //改变页数
    changePage(pagination, filters, sorter) {
      ;[this.delPage, this.delSize] = [pagination.current, pagination.pageSize]
    },
    //点击下载失败数据
    dowLoad(index) {
      if (this.forData.errorCount == false) return this.$message.info('暂无失败')
      let sendData = {
        downloadType: index
      }
      api.NewGetApi_file('/exportVacancy/downloadFailDeviceData', sendData).then(res => {
        dowLoadFile(res.data, this.param.value == 1 ? '失败网点' : '失败点位')
        // window.location.href = res.data.data;
      })
    },
    //点击删除本页
    handleClickRow(v, e) {
      let that = this
      let arrData = that.dataSource //拿到数据源
      return {
        on: {
          click: () => {
            let arr = this.columns.filter(i => {
              return i.key == 'remove'
            })
            if (arr.length == 0) return
            that.$confirm({
              title: '确定要删除本页吗',
              onOk() {
                let start = that.delPage * that.delSize - that.delSize //开始位置
                let end = that.delPage * that.delSize //结束位置
                let [allNum, idArr, sonArr, delArr, newArr] = [0, [], [], that.onesDel, []]
                newArr = arrData.splice(start, that.delSize) //删除
                newArr.map(i => {
                  idArr.push({ id: i.communityId })
                })
                that.forData.pointArr.forEach(item => {
                  idArr.forEach(v => {
                    if (item.communityId == v.id) {
                      sonArr.push(v.id)
                      item.pointNum--
                      if (item.pointNum == 0) {
                        --delArr
                      }
                    }
                  })
                })
                that.$set(that, 'onesDel', delArr)
                that.newNum -= sonArr.length
                that.pagePagination.total = that.newNum
                that.$set(that, 'dataSource', arrData)
                that.$forceUpdate()
              },
              onCancel() {}
            })
          }
        }
      }
    },
    // 删除
    onDelete(e, index) {
      if (this.delPage != 1) {
        index = this.delPage * this.delSize + index - this.delSize
      }
      let [data, id, lessNum, that] = [
        this.forData.pointArr,
        this.dataSource[index].communityId,
        [],
        this
      ]
      data.forEach(i => {
        if (i.communityId == id) {
          lessNum.push(i.pointNum)
          if (i.pointNum != 0) {
            --i.pointNum
            if (i.pointNum == 0) that.onesDel--
          } else {
            that.onesDel--
          }
        }
      })
      this.newNum -= lessNum.length
      if (this.dataSource.length == 1) {
        //如果只剩一个制空数组
        this.dataSource = []
      } else {
        this.dataSource.splice(index, 1)
        this.pagePagination.total = this.dataSource.length
      }
    },
    //当前选中点位
    selecClick(index) {
      if (this.selectBox == index) return
      let that = this
      that.dataSource = []
      if (!index) {
        //成功状态赋值
        that.dataSource = that.forData.successDeviceList
      } else {
        //失败赋值
        that.dataSource = that.forData.failDeviceList
      }
      //给总数赋值
      if (index == 1 && that.param.value == 1) {
        that.columns = formHeardData.TabHeardFailW
      } else if (index == 0 && that.param.value == 1) {
        that.columns = formHeardData.TabHeardSuccW
      } else if (index == 1 && that.param.value == 2) {
        that.columns = formHeardData.failPoint
      } else if (index == 0 && that.param.value == 2) {
        that.columns = formHeardData.succPoint
      }
      that.pagePagination.total = that.dataSource.length
      that.selectBox = index
    },
    beforeUploadFun(v) {
      this.param.spaceId =
        sessionStorage.getItem('spaceId') - 0 ? sessionStorage.getItem('spaceId') - 0 : 1
      this.sendFileObj = JSON.parse(sessionStorage.getItem('importWorkeFun'))
    },
    handleChange(info) {
      if (info.file.status !== 'uploading') {
      }
      if (info.file.status === 'done') {
        this.$message.success(`${info.file.name} 上传成功！`)
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} 上传失败！请重试！`)
      }
      //不管上传还是删除都把改变后的值拿过来
      this.awitDealWithData = info.fileList
    },
    //导出空位的选择
    valChange(v) {
      this.awitDealWithData = []
      this.param.value = v.target.value
    },
    dowTemplate() {
      let href =
        this.param.value == 1
          ? 'https://yxy-1256017579.cos.ap-guangzhou.myqcloud.com/QFAD/template/%E7%BD%91%E7%82%B9%E6%A8%A1%E6%9D%BF.xls'
          : 'https://yxy-1256017579.cos.ap-guangzhou.myqcloud.com/QFAD/template/%E7%82%B9%E4%BD%8D%E6%A8%A1%E6%9D%BF.xls'
      let downloadElement = document.createElement('a')
      downloadElement.href = href
      downloadElement.target = '_blank' // 针对 ie模式 的浏览器
      document.body.appendChild(downloadElement)
      downloadElement.click() //点击下载
      document.body.removeChild(downloadElement) //下载完成移除元素
    },
    newHandleOk() {
      if (this.awitDealWithData.length == 0) return this.$message.info('请检查您上传的文件！')
      if (this.awitDealWithData[0].response.code != 200)
        // return this.$message.error(this.awitDealWithData[0].response.msg);
        return this.$message.error('请根据模板内容填写并上传')
      this.$emit('offPop', false)
      this.newNum = 0
      //this.param.value上传文件的类型 1 网点 2是点位
      this.columns = []
      if (this.param.value == 2) {
        this.columns = formHeardData.succPoint
      } else {
        this.columns = formHeardData.TabHeardSuccW
      }
      let [
        cleanData,
        all,
        successCount,
        errorCount,
        successDeviceList,
        failDeviceList,
        topBarCountData,
        pointArr,
        emptyArr,
        temporary,
        newEmpty,
        obj
      ] = [[], {}, 0, 0, [], [], 0, [], [], [], [], {}]
      //先把data拿出来
      this.awitDealWithData.map(item => {
        cleanData.push({ data: item.response.data })
      })

      let that = this
      if (cleanData[0].data.topBarCountData != false) {
        pointArr = cleanData[0].data.topBarCountData || 0
      }
      cleanData.forEach(i => {
        successCount += i.data.successCount == false ? 0 : i.data.successCount
        errorCount += i.data.errorCount == false ? 0 : i.data.errorCount
        //拿点位
        //插件不加key报错
        if (i.data.failDeviceList) {
          i.data.failDeviceList.forEach((item, index) => {
            item.key = index
          })
        } else {
          i.data.failDeviceList = []
        }
        if (i.data.successDeviceList) {
          i.data.successDeviceList.forEach((item, index) => {
            item.key = index
          })
        } else {
          i.data.successDeviceList = []
        }
        successDeviceList.push(...i.data.successDeviceList)
        failDeviceList.push(...i.data.failDeviceList)
        if (i.data.topBarCountData) {
          emptyArr.push(...i.data.topBarCountData)
        }
      })
      //找出不一样的添加到临时数组里，找出一样的，点数增加
      emptyArr.forEach((item, key) => {
        newEmpty.push(item.communityId)
        pointArr.forEach(v => {
          if (item.communityId == v.communityId) {
            temporary.push({
              communityId: item.communityId,
              pointNum: (item.pointNum += v.pointNum)
            })
          } else {
            temporary.push({
              communityId: item.communityId,
              pointNum: item.pointNum
            })
          }
        })
      })
      //去重
      for (let i = 0; i < temporary.length; i++) {
        if (newEmpty.indexOf(temporary[i].communityId) == -1) {
          pointArr.push(temporary[i])
        }
      }
      this.forData = {
        successCount,
        errorCount,
        successDeviceList,
        failDeviceList,
        pointArr
      }

      this.delPage = 1
      this.delSize = 10
      this.dataSource = []
      this.dataSource.push(...this.forData.successDeviceList)
      if (that.param.value == 1) {
        that.onesDel = pointArr.length
        //拿所有成功和失败
        that.newNum = this.dataSource.length
      }

      this.tablePop = true
      this.$emit('offPop', false)
    },
    offPop() {
      this.$emit('offPop', false)
    },
    //关闭表格弹窗
    tablePopFun(index) {
      let arr = []
      let b = []
      let seesin = []
      this.dataSource.forEach(res => {
        b.push(res.id)
      })
      if (index == 1) {
        this.dataSource.forEach((i, index) => {
          arr.push({
            ...i,
            id: i.id,
            areaString: i.province + '-' + i.city + '-' + i.area,
            communityName: i.communityName,
            mac: i.mac,
            deviceName: i.deviceName,
            deviceModelText: i.deviceModelText,
            onlineStatus: i.onlineStatus,
            onlineDayNum: i.onlineDayNum || 0 + '天',
            deviceName: i.pointName || i.deviceName
          })
        })
        var obj = {}
        this.$store.commit('inputNetworkFun', arr)
      }
      if (JSON.parse(sessionStorage.getItem('areaDataListRow')) != null) {
        let ass = JSON.parse(sessionStorage.getItem('areaDataListRow'))
        seesin = arr.map(item => item.id)
        seesin.push(...ass)
      }
      sessionStorage.setItem('areaDataListRow', JSON.stringify(seesin))
      this.tablePop = false
      this.selectBox = 0
      this.delPage = 1
    }
  }
}
</script>

<style scoped lang="scss">
* {
  margin: 0;
  padding: 0;
}
.dow {
  span {
    border: 1px solid #ccc;
    border-radius: 10px;
    padding: 0 5px;
    cursor: pointer;
  }
}
.instructions {
  margin-top: 10px;
  color: #cccccc;
  font-size: 12px;
}
.button {
  width: 100px;
}
.goUp {
  border: 1px solid #ccc;
  border-radius: 10px;
  padding: 0 5px;
  cursor: pointer;
}
.title {
  color: #000;
}
.content-line {
  padding: 8px 40px;
  font-size: 13px;
  span {
    color: rgb(2, 167, 240);
  }
  .a {
    border-bottom: 1px solid rgb(2, 167, 240);
    margin-left: 10px;
    cursor: pointer;
  }
}
.switch {
  display: flex;
  align-items: center;
  p {
    margin: 10px 0;
    width: 89px;
    font-size: 13px;
    border: 1px solid #ccc;
    text-align: center;
    line-height: 30px;
    border-bottom: 0;
    border-radius: 5px 5px 0 0;
    background: rgb(243, 243, 243);
    &:hover {
      cursor: pointer;
    }
  }
  .prompt {
    margin-left: 20px;
    font-size: 14px;
    span {
      font-weight: bold;
      color: rgb(2, 167, 240);
    }
  }
}
.addUti {
  color: rgb(2, 167, 240);
  background: #ffffff !important;
}
.delText {
  border-bottom: 1px solid rgb(2, 167, 240);
}
</style>
<style lang="scss">
.del {
  .ant-table-header-column {
    div {
      .ant-table-column-title {
        font-size: 14px;
        color: rgb(2, 167, 240);
        font-weight: 400;
        border-bottom: 1px solid rgb(2, 167, 240);
        &:hover {
          cursor: pointer;
        }
      }
    }
  }
}
</style>
